'use strict';
import React, { PureComponent } from 'react';


class CuentasContablesRegistrosBuscador extends PureComponent {
    constructor(props) {
        super(props);

        this.cambiarInputActivo = this.cambiarInputActivo.bind(this);
    }

    cambiarInputActivo(descripcionCuenta) {
        this.props.cambiarInputActivo(this.props.seccionInput, "");
        this.props.onValorReferenciaChange(this.props.nroRenglon, "0")
        this.props.cambiarValorInput(descripcionCuenta);
        this.props.guardarValorInput(this.props.cuenta.Id, this.props.cuenta.Codigo, descripcionCuenta)  
    }

    render() {
        const { cuenta } = this.props;

        let descripcionCuenta = cuenta.Codigo + " - " + cuenta.Descripcion

        return (
            <div className="ABMModelos__opcionBuscadorCuentasContables" onClick={() => this.cambiarInputActivo(descripcionCuenta)}>
                {descripcionCuenta}
            </div>
        );
    }
}

export default CuentasContablesRegistrosBuscador;